/* ============================================================
   クール便の選択 / 配送情報フィールド — カートページ専用
   設計: docs/cool-delivery/cool-delivery-auto-apply-proposal.html

   中核の状態ルール（設計書 §4-C）:
     cart attribute「クール便」は、お客様が明示的にトグルを操作したときだけ書き込む。
     記録がなければ毎回「要冷蔵商品の有無」から自動判定する。
     → システムが勝手に ON へ戻すと、気づかないうちに料金が加算されるため。

   個口数は送料設定と同じ重量帯で算出する。商品重量は実重量ではなく
   送料計算用の係数値（720ml=1kg / 1.8L=2kg）が登録されているため
   cart.total_weight をそのまま使える。
   出典: Tools/20260605_iseya_shipping_rules/config/iseya-shipping-rules.json
   ※ 送料設定を変更したら WEIGHT_BANDS も必ず同期すること。
   ============================================================ */

(function () {
  'use strict';

  var WEIGHT_BANDS = [
    { maxKg: 12, parcels: 1 },
    { maxKg: 24, parcels: 2 },
    { maxKg: 36, parcels: 3 }
  ];

  var ATTR_COOL = 'クール便';
  var VAL_USE = '利用する';
  var VAL_NOT_USE = '利用しない';

  /*
    以前は「お客様が選んだのか未操作なのか」を内部フラグで持っていたが廃止した。
    アンダースコア始まりでも cart attribute は注文の「追加詳細」に表示されるため
    （非表示になるのは line item properties の方）、受注画面にノイズが出ていた。

    記録はチェックアウトへ進む直前にしか行わないので、カート内で商品を入れ替えて
    いる間は記録が無く、自動判定がそのまま働く（観点 T5d は影響を受けない）。
    チェックアウトから戻って編集した場合だけ、直前の選択が維持される挙動になる。

    この定数は、旧実装が書き込んだキーを消すためだけに残している。
  */
  var ATTR_COOL_BY_LEGACY = '_cool_choice_by';

  var WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

  // 注文管理画面の「追加詳細」は cart attribute の登録順に並ぶ。お客様が入力した
  // 順のままだと受注時に読む順序が毎回変わるため、この順に整える（店側の指定）。
  var ATTR_ORDER = ['クール便', '配送希望日', '配送希望時間', '領収書', '備考'];

  var root = document.querySelector('[data-cool-option]');
  var fields = document.querySelector('[data-delivery-fields]');

  // 未入力の欄に入れる値。項目ごと消すと受注側で「書かれなかった」のか
  // 「見落とし」なのか区別できないため、空欄でも項目自体は残す。
  // 文言は Liquid から data 属性で受け取る。書き込む側（ここ）と入力欄へ戻す
  // 判定（cart-delivery-fields.liquid）が同じ値を見るようにするため。
  var VAL_NONE = (fields && fields.dataset.noneValue) || '（未入力）';
  // 空カートでは root も fields も描画されない。持ち越された選択を破棄する
  // ためだけに動く必要があるので、専用のマーカーも入口の条件に含める。
  var emptyCartReset = document.querySelector('[data-cool-reset]');
  if (!root && !fields && !emptyCartReset) return;

  /* ---------- 共通ユーティリティ ---------- */

  // カート更新は必ず1本のキューに直列化する。
  // トグル操作・数量変更・フィールド入力が同時に走っても競合しないようにするため。
  var queue = Promise.resolve();
  var syncing = false;

  function enqueue(task) {
    queue = queue.then(task).catch(function (err) {
      console.error('[cool-delivery]', err);
    });
    return queue;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' failed: ' + res.status);
      return res.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function parcelCount(totalGrams) {
    var kg = totalGrams / 1000;
    for (var i = 0; i < WEIGHT_BANDS.length; i++) {
      if (kg <= WEIGHT_BANDS[i].maxKg) return WEIGHT_BANDS[i].parcels;
    }
    // 最大帯を超えた場合のフォールバック（送料側に帯を追加したらここも同期する）
    return Math.ceil(kg / WEIGHT_BANDS[0].maxKg);
  }

  function formatYen(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  /* ---------- 注文へ残す追加詳細の確定 ---------- */

  /*
    チェックアウトへ進む直前に、注文の「追加詳細」に残る内容を確定させる。

    (1) 未入力の項目も既定値で記録する。フィールドは change でしか保存しないため、
        何も触らずに注文されると項目ごと消え、受注側で「選ばれなかった」のか
        「見落とし」なのか区別できない。
    (2) ATTR_ORDER の順に並べ直す。cart attribute は登録順に保持され、
        注文管理画面の「追加詳細」もその順で表示されるため。

    既存キーは値を更新するだけでは位置が変わらないので、一度消してから入れ直す。
    往復が 2 回に増えるが、入力のたびではなくここで一度だけ行う。
  */
  function finalizeAttributes(coolValue) {
    return getCart().then(function (cart) {
      var current = cart.attributes || {};
      var values = {};

      // 配送情報の入力欄。触られていなくても選択式には既定値が入っている。
      // ここで拾わないと、何も操作しない注文で項目ごと消えてしまう。
      var container = document.querySelector('[data-delivery-fields]');
      if (container) {
        container.querySelectorAll('[name]').forEach(function (el) {
          var match = el.name && el.name.match(/^attributes\[(.+)\]$/);
          if (!match) return;
          values[match[1]] = (el.value || '').trim() || VAL_NONE;
        });
      }

      if (coolValue) values[ATTR_COOL] = coolValue;

      // 設計外のキー（他アプリが付けたものなど）は落とさず引き継ぐ
      Object.keys(current).forEach(function (key) {
        if (key.charAt(0) === '_') return;
        if (!(key in values) && current[key]) values[key] = current[key];
      });

      var ordered = {};
      ATTR_ORDER.forEach(function (key) {
        if (values[key]) ordered[key] = values[key];
      });
      Object.keys(values).forEach(function (key) {
        if (!(key in ordered)) ordered[key] = values[key];
      });

      var presentNow = Object.keys(current).filter(function (key) {
        return key.charAt(0) !== '_' && current[key];
      });
      var unchanged =
        Object.keys(ordered).join(' ') === presentNow.join(' ') &&
        Object.keys(ordered).every(function (key) {
          return current[key] === ordered[key];
        });
      // 旧実装が書き込んでいた内部キーは、この機会に消す（受注画面に出てしまうため）
      var hasLegacy = !!current[ATTR_COOL_BY_LEGACY];
      if (unchanged && !hasLegacy) return null;

      // 既存キーは値を更新するだけで位置が変わらないため、一度消してから入れ直す
      var cleared = {};
      presentNow.forEach(function (key) {
        cleared[key] = '';
      });
      if (hasLegacy) cleared[ATTR_COOL_BY_LEGACY] = '';

      return postJSON('/cart/update.js', { attributes: cleared }).then(function () {
        return postJSON('/cart/update.js', { attributes: ordered });
      });
    });
  }

  /* ---------- 空カートでの選択リセット ---------- */

  /*
    カートを空にする操作は買い物のリセットとみなし、お客様が選んだクール便の
    指定を破棄する。attribute はカートが空でも残るため、破棄しないと
    「常温商品だけを入れ直したのに ¥380 が付く」状態になり、選んだ本人にとっても
    意図しない課金に見える（仕様確認 2026-08-03 / 設計書 §4-C・T5g）。

    未操作の状態へ戻すだけなので、次に要冷蔵商品を入れれば自動判定が働く。
  */
  if (emptyCartReset) {
    enqueue(function () {
      var attrs = {};
      attrs[ATTR_COOL] = '';
      return postJSON('/cart/update.js', { attributes: attrs });
    });
  }

  /* ---------- クール便ブロック ---------- */

  if (root) {
    var coolVariantId = parseInt(root.dataset.variantId, 10);
    var coolFee = parseInt(root.dataset.fee, 10);

    var elBadge = root.querySelector('[data-cool-badge]');
    var elLead = root.querySelector('[data-cool-lead]');
    var elPill = root.querySelector('[data-cool-pill]');
    // 文言は Liquid（locale ファイル）から受け取る。JS 側に文言を持たない。
    var tplLead = root.dataset.tplLead || '';
    var tplSummary = root.dataset.tplSummary || '';
    var tplReason = root.dataset.tplReason || '';
    var tplFeeLabel = root.dataset.tplFeeLabel || '';

    function fill(tpl, values) {
      return Object.keys(values).reduce(function (s, k) {
        return s.split('__' + k + '__').join(String(values[k]));
      }, tpl);
    }

    var elSummary = root.querySelector('[data-cool-summary]');
    var elSummaryText = root.querySelector('[data-cool-summary-text]');
    var elReason = root.querySelector('[data-cool-parcel-reason]');
    var elNotice = root.querySelector('[data-cool-notice]');
    var choices = root.querySelectorAll('[data-cool-choice]');

    /**
     * カートの中身から現在あるべき状態を導出する。
     * touched=false（お客様が未操作）のときだけ自動判定を適用するのが要点。
     */
    function derive(cart) {
      var hasCold = false;
      var coldCount = 0;
      var goodsCount = 0;
      var coolLineQty = 0;

      cart.items.forEach(function (item) {
        if (item.variant_id === coolVariantId) {
          coolLineQty = item.quantity;
          return;
        }
        goodsCount += item.quantity;
        // 要冷蔵判定は商品詳細ページのバッジと同一条件（タグ／商品名に「要冷蔵」）。
        // /cart.js は商品タグを返さないため、サーバ側（Liquid）が埋めた
        // 要冷蔵バリアント一覧を主に使い、title / handle は補助とする。
        if (isCold(item)) {
          hasCold = true;
          coldCount += item.quantity;
        }
      });

      var attrs = cart.attributes || {};
      var attr = attrs[ATTR_COOL] || '';
      var useCool;
      if (attr.indexOf('利用する') !== -1) {
        useCool = true;
      } else if (attr.indexOf('利用しない') !== -1) {
        useCool = false;
      } else {
        useCool = hasCold;
      }

      return {
        hasCold: hasCold,
        coldCount: coldCount,
        goodsCount: goodsCount,
        coolLineQty: coolLineQty,
        useCool: useCool,
        parcels: parcelCount(cart.total_weight),
        cartTotal: cart.total_price
      };
    }

    // 要冷蔵バリアントの一覧はサーバ側（Liquid）がカート描画時に埋め込む。
    // タグは /cart.js から取得できないため、この埋め込みが主たる判定根拠になる。
    var COLD_VARIANTS = window.__cdColdVariants || [];
    function isCold(item) {
      if (COLD_VARIANTS.indexOf(item.variant_id) !== -1) return true;
      if ((item.product_title || '').indexOf('要冷蔵') !== -1) return true;
      // ハンドルに「要冷蔵」を含む商品も拾う（別タブでの追加など、
      // 埋め込み一覧が古くなった場合の保険）
      if ((item.handle || '').indexOf('要冷蔵') !== -1) return true;
      return false;
    }

    function toggle(el, show) {
      if (!el) return;
      if (show) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    }

    function render(state) {
      root.dataset.hasCold = String(state.hasCold);
      root.dataset.parcels = String(state.parcels);
      root.dataset.selected = state.useCool ? 'cool' : 'ambient';

      toggle(elBadge, state.hasCold);
      toggle(elLead, state.hasCold);
      toggle(elPill, state.hasCold);

      if (elLead && state.hasCold) {
        elLead.textContent = fill(tplLead, { COUNT: state.coldCount });
      }

      choices.forEach(function (label) {
        var selected = label.dataset.coolChoice === (state.useCool ? 'cool' : 'ambient');
        label.classList.toggle('is-selected', selected);
        var input = label.querySelector('input');
        if (input) input.checked = selected;
      });

      toggle(elSummary, state.useCool);
      if (elSummary && state.useCool) {
        if (elSummaryText) {
          elSummaryText.textContent = fill(tplSummary, {
            FEE: formatYen(coolFee),
            PARCELS: state.parcels,
            TOTAL: formatYen(coolFee * state.parcels)
          });
        }
        toggle(elReason, state.parcels > 1);
        if (elReason && state.parcels > 1) {
          elReason.textContent = fill(tplReason, { PARCELS: state.parcels });
        }
      }

      // 常温を選んでいて、かつ要冷蔵商品があるときだけ注意表示を出し続ける
      toggle(elNotice, !state.useCool && state.hasCold);

      renderSummaryLines(state);
    }

    /** 小計の内訳（商品計 / クール便配送料）。クール便利用時のみ表示する */
    var elLines = document.querySelector('[data-cool-summary-lines]');
    function renderSummaryLines(state) {
      if (!elLines) return;
      var show = state.useCool && state.coolLineQty > 0;
      toggle(elLines, show);
      if (!show) return;

      var coolTotal = coolFee * state.coolLineQty;
      var itemsEl = elLines.querySelector('[data-items-total]');
      var labelEl = elLines.querySelector('[data-cool-fee-label]');
      var totalEl = elLines.querySelector('[data-cool-fee-total]');

      if (itemsEl) itemsEl.textContent = formatYen(state.cartTotal - coolTotal);
      if (labelEl) labelEl.textContent = fill(tplFeeLabel, { PARCELS: state.coolLineQty });
      if (totalEl) totalEl.textContent = formatYen(coolTotal);
    }

    /**
     * クール便商品の数量をあるべき個口数に合わせる。
     * 「目標数量 == 現在数量なら何もしない」ループガード付き。
     */
    function syncCoolLine(state) {
      var target = state.useCool && state.goodsCount > 0 ? state.parcels : 0;
      if (target === state.coolLineQty) return Promise.resolve(null);

      if (state.coolLineQty === 0) {
        return postJSON('/cart/add.js', {
          items: [{ id: coolVariantId, quantity: target }]
        });
      }
      return postJSON('/cart/change.js', {
        id: String(coolVariantId),
        quantity: target
      });
    }

    /**
     * 商品がすべて無くなったか（クール便配送料の行だけが残った状態も含む）を見て、
     * 選択の記録が残っていれば破棄すべきかを判定する。
     */
    function needsReset(cart) {
      var attr = (cart.attributes && cart.attributes[ATTR_COOL]) || '';
      if (!attr) return false;
      var goods = 0;
      cart.items.forEach(function (item) {
        if (item.variant_id !== coolVariantId) goods += item.quantity;
      });
      return goods === 0;
    }

    function clearCoolChoice() {
      var attrs = {};
      attrs[ATTR_COOL] = '';
      // 旧実装が書き込んでいた内部キーも落とす
      attrs[ATTR_COOL_BY_LEGACY] = '';
      return postJSON('/cart/update.js', { attributes: attrs });
    }

    /** カートを読み直して表示と数量を整える（引数なしで現状に追従する） */
    function refresh() {
      if (syncing) return Promise.resolve();
      syncing = true;
      return getCart()
        .then(function (cart) {
          // カートを空にする操作は買い物のリセットとみなし、選択の記録を破棄する。
          // テーマは [data-products] の中身だけを差し替えページを再読み込みしないため、
          // Liquid 側では検知できない。カート更新のたびにここで見る（§4-C・T5g）。
          if (!needsReset(cart)) return cart;
          return clearCoolChoice().then(getCart);
        })
        .then(function (cart) {
          var state = derive(cart);
          render(state);
          return syncCoolLine(state).then(function (updated) {
            if (!updated) return;
            // クール便商品の数量が変わったら、更新後のカートで表示を作り直す。
            // 上の render は「追加する前」のカートを見ているため、
            // そのままだと小計の内訳（商品計・クール便配送料）が
            // 古い状態のまま（利用する に切り替えても非表示のまま）になる。
            return getCart().then(function (cart2) {
              var state2 = derive(cart2);
              render(state2);
              // 明細と小計はテーマ側が描き直す
              document.dispatchEvent(new CustomEvent('cart:build'));

              // 追加の結果、カート側の数量が動くことがある（在庫上限による切り詰めなど）。
              // その場合ここで個口数が変わるので、もう一度だけ合わせ直す。
              // 再試行を 1 回に限るのは、往復が無限に続くのを防ぐため。
              return syncCoolLine(state2).then(function (again) {
                if (!again) return;
                return getCart().then(function (cart3) {
                  render(derive(cart3));
                  document.dispatchEvent(new CustomEvent('cart:build'));
                });
              });
            });
          });
        })
        .finally(function () {
          syncing = false;
        });
    }

    /** お客様が明示的に選択したときだけ attribute を書き込む */
    function choose(next) {
      var attrs = {};
      attrs[ATTR_COOL] = next === 'cool' ? VAL_USE : VAL_NOT_USE;
      enqueue(function () {
        return postJSON('/cart/update.js', { attributes: attrs }).then(function () {
          return refresh();
        });
      });
    }

    choices.forEach(function (label) {
      label.addEventListener('click', function (e) {
        e.preventDefault();
        choose(label.dataset.coolChoice);
      });
      var input = label.querySelector('input');
      if (input) {
        input.addEventListener('change', function () {
          choose(label.dataset.coolChoice);
        });
      }
    });

    var switchBtn = root.querySelector('[data-cool-switch]');
    if (switchBtn) {
      switchBtn.addEventListener('click', function () {
        choose('cool');
      });
    }

    /* 明細の変化に追従する。
       テーマは [data-products] の中身だけを差し替えるため、その変化を監視すれば
       数量変更・削除のあとに再計算できる。自分の更新でも発火するので
       refresh() 側のループガードと合わせて二重に守る。 */
    var products = document.querySelector('[data-products]');
    if (products && 'MutationObserver' in window) {
      var timer = null;
      new MutationObserver(function () {
        if (syncing) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          enqueue(refresh);
        }, 120);
      }).observe(products, { childList: true, subtree: true });
    }

    /* テーマは数量変更のたびに cart:updated を発火する（theme.js の quantityChanged）。
       MutationObserver は [data-products] の差し替え方に依存し、数量だけが変わる
       更新を取りこぼすことがあるため、こちらを主の入口にする。
       自分の更新は /cart/change.js を直接叩いていてテーマの経路を通らないので、
       このイベントは飛ばず、ループにはならない。 */
    var updatedTimer = null;
    document.addEventListener('cart:updated', function () {
      clearTimeout(updatedTimer);
      updatedTimer = setTimeout(function () {
        enqueue(refresh);
      }, 80);
    });

    /* チェックアウトへ進む前に同期を完了させる（個口数が古いまま決済に進むのを防ぐ）。

       押されたボタンを控えておくのが要点。form.submit() はプログラム送信であり、
       submitter のボタンの name/value が送られない。購入ボタンは name="checkout"
       （sections/main-cart.liquid）なので、これが落ちると Shopify はカートの更新
       として扱い、チェックアウトへ進まずカートページへ戻る。 */
    var cartForm = document.getElementById('CartPageForm');
    if (cartForm) {
      var submitting = false;
      var enterInField = false;

      /* 数量欄で Enter を押すと、ブラウザの暗黙送信でフォームが送信される。
         このときフォーム内の最初の送信ボタンが submitter として扱われるため、
         購入ボタン（name="checkout"）を押したのと同じ扱いになりチェックアウトへ進む。
         テーマは数量変更を Ajax で処理する作りなので、この送信自体が不要。

         preventDefault だけでは環境差で漏れることがあるので、直後の submit も
         フラグで弾く二段構えにする。 */
      cartForm.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.keyCode !== 13) return;
        var el = e.target;
        if (!el || el.tagName !== 'INPUT') return;
        enterInField = true;
        e.preventDefault();
        el.blur(); // change を発火させ、テーマの Ajax 更新に載せる
        setTimeout(function () {
          enterInField = false;
        }, 0);
      });

      cartForm.addEventListener('submit', function (e) {
        if (enterInField) {
          // 入力欄での Enter は「入力の確定」であって購入の意思ではない
          e.preventDefault();
          return;
        }
        if (submitting) return;
        e.preventDefault();
        submitting = true;
        var submitter = e.submitter;
        enqueue(refresh);
        // 未操作の項目も既定値で残し、受注画面で読む順序を揃えてから送る
        enqueue(function () {
          return getCart().then(function (cart) {
            var attrs = cart.attributes || {};
            var coolValue = attrs[ATTR_COOL] || (derive(cart).useCool ? VAL_USE : VAL_NOT_USE);
            return finalizeAttributes(coolValue);
          });
        }).then(function () {
          // requestSubmit なら submitter をそのまま渡せる（submit が再発火するが
          // submitting=true で素通りし、ブラウザが通常どおり送信する）。
          if (submitter && typeof cartForm.requestSubmit === 'function') {
            cartForm.requestSubmit(submitter);
            return;
          }
          // 未対応環境では、押されたボタンの値を隠しフィールドで補ってから送る。
          if (submitter && submitter.name) {
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = submitter.name;
            hidden.value = submitter.value || '';
            cartForm.appendChild(hidden);
          }
          cartForm.submit();
        });
      });
    }

    enqueue(refresh);
  }

  /* ---------- 配送情報フィールド ---------- */

  if (fields) {
    var leadDays = parseInt(fields.dataset.leadDays, 10) || 5;
    var maxDays = parseInt(fields.dataset.maxDays, 10) || 10;
    var dateSelect = fields.querySelector('[data-delivery-date]');

    /** JST の「今日」を UTC ミリ秒として得る（端末のタイムゾーンに依存させない） */
    function jstTodayMs() {
      var s = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Tokyo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
      var parts = s.split('-').map(Number);
      return Date.UTC(parts[0], parts[1] - 1, parts[2]);
    }

    function formatDate(ms) {
      var d = new Date(ms);
      var y = d.getUTCFullYear();
      var m = String(d.getUTCMonth() + 1).padStart(2, '0');
      var day = String(d.getUTCDate()).padStart(2, '0');
      return y + '/' + m + '/' + day + '(' + WEEKDAYS[d.getUTCDay()] + ')';
    }

    /* 配送希望日の選択肢を生成する。
       締め時刻は 23:59（＝暦日基準）のため、締めロジックは不要。
       休業日の除外は現行アプリでも未使用のため実装しない（設計書 §4-F）。 */
    if (dateSelect) {
      var current = dateSelect.dataset.current || '';
      var base = jstTodayMs();
      var frag = document.createDocumentFragment();

      for (var n = leadDays; n <= maxDays; n++) {
        var value = formatDate(base + n * 86400000);
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        if (value === current) opt.selected = true;
        frag.appendChild(opt);
      }

      // Liquid が保険で描画した「現在値」の option は、生成した一覧と重複するので除去する
      Array.prototype.slice.call(dateSelect.options).forEach(function (opt, i) {
        if (i > 0) dateSelect.removeChild(opt);
      });
      dateSelect.appendChild(frag);
      if (current) dateSelect.value = current;
    }

    /** 入力値を cart attribute に保存する（キュー経由で他の更新と直列化） */
    function saveAttr(name, value) {
      var attrs = {};
      attrs[name] = value;
      enqueue(function () {
        return postJSON('/cart/update.js', { attributes: attrs });
      });
    }

    function bind(el) {
      if (!el || !el.name) return;
      var match = el.name.match(/^attributes\[(.+)\]$/);
      if (!match) return;
      var key = match[1];
      var evt = el.tagName === 'TEXTAREA' ? 'change' : 'change';
      el.addEventListener(evt, function () {
        saveAttr(key, el.value);
      });
    }

    bind(dateSelect);
    fields.querySelectorAll('[data-delivery-attr]').forEach(bind);
  }
})();
